import { SIGN_UP_ACT, SIGN_UP_CLEARE_TEMP, SIGN_UP_ERR } from "src/Helper/actionsTypes";

export const SignUpReducer = (state=[], action) =>{
    switch (action.type){
        case  SIGN_UP_ACT :{
            return {...state, success:true, signupmessage:action.payload.message, token:action.payload.results.token}
        }
        case SIGN_UP_ERR:{
            return {...state, success:false, signupmessage:action.payload.message}
        }
        case SIGN_UP_CLEARE_TEMP:{
            return {...state, success:null, signupmessage:null}
        }
        default: return state;
    }

}